/*
 * Пресеты обложек Comabooks для админки (зеркало backend/src/data/comabooksCovers.ts).
 * thumb — кнопка селектора старого клиента. Печать строит бэкенд
 * (services/coverGeneratorComabooks.ts), plate_preset для них не действует.
 */
import g1black from '../../assets/comabooks-covers/cb-1-black.webp';
import g1blue from '../../assets/comabooks-covers/cb-1-blue.webp';
import g1green from '../../assets/comabooks-covers/cb-1-green.webp';
import g1lightgreen from '../../assets/comabooks-covers/cb-1-lightgreen.webp';
import g1red from '../../assets/comabooks-covers/cb-1-red.webp';
import g1brown from '../../assets/comabooks-covers/cb-1-brown.webp';
import g2black from '../../assets/comabooks-covers/cb-2-black.webp';
import g2blue from '../../assets/comabooks-covers/cb-2-blue.webp';
import g2green from '../../assets/comabooks-covers/cb-2-green.webp';
import g2lightgreen from '../../assets/comabooks-covers/cb-2-lightgreen.webp';
import g2red from '../../assets/comabooks-covers/cb-2-red.webp';
import g2brown from '../../assets/comabooks-covers/cb-2-brown.webp';
import g3black from '../../assets/comabooks-covers/cb-3-black.webp';
import g3blue from '../../assets/comabooks-covers/cb-3-blue.webp';
import g3green from '../../assets/comabooks-covers/cb-3-green.webp';
import g3lightgreen from '../../assets/comabooks-covers/cb-3-lightgreen.webp';
import g3red from '../../assets/comabooks-covers/cb-3-red.webp';
import g3brown from '../../assets/comabooks-covers/cb-3-brown.webp';
import g4black from '../../assets/comabooks-covers/cb-4-black.webp';
import g4blue from '../../assets/comabooks-covers/cb-4-blue.webp';
import g4green from '../../assets/comabooks-covers/cb-4-green.webp';
import g4lightgreen from '../../assets/comabooks-covers/cb-4-lightgreen.webp';
import g4red from '../../assets/comabooks-covers/cb-4-red.webp';
import g4brown from '../../assets/comabooks-covers/cb-4-brown.webp';

export interface ComabooksCoverOption {
  id: string;
  group: 1 | 2 | 3 | 4;
  name: string;
  thumb: string;
}

export const COMABOOKS_COVERS: ComabooksCoverOption[] = [
  { id: 'cb-1-black', group: 1, name: 'Дизайн 1 · чёрный', thumb: g1black },
  { id: 'cb-1-blue', group: 1, name: 'Дизайн 1 · синий', thumb: g1blue },
  { id: 'cb-1-green', group: 1, name: 'Дизайн 1 · тёмно-зелёный', thumb: g1green },
  { id: 'cb-1-lightgreen', group: 1, name: 'Дизайн 1 · светло-зелёный', thumb: g1lightgreen },
  { id: 'cb-1-red', group: 1, name: 'Дизайн 1 · бордовый', thumb: g1red },
  { id: 'cb-1-brown', group: 1, name: 'Дизайн 1 · жёлтый', thumb: g1brown },
  { id: 'cb-2-black', group: 2, name: 'Дизайн 2 · чёрный', thumb: g2black },
  { id: 'cb-2-blue', group: 2, name: 'Дизайн 2 · синий', thumb: g2blue },
  { id: 'cb-2-green', group: 2, name: 'Дизайн 2 · тёмно-зелёный', thumb: g2green },
  { id: 'cb-2-lightgreen', group: 2, name: 'Дизайн 2 · светло-зелёный', thumb: g2lightgreen },
  { id: 'cb-2-red', group: 2, name: 'Дизайн 2 · бордовый', thumb: g2red },
  { id: 'cb-2-brown', group: 2, name: 'Дизайн 2 · жёлтый', thumb: g2brown },
  { id: 'cb-3-black', group: 3, name: 'Дизайн 3 · чёрный', thumb: g3black },
  { id: 'cb-3-blue', group: 3, name: 'Дизайн 3 · синий', thumb: g3blue },
  { id: 'cb-3-green', group: 3, name: 'Дизайн 3 · тёмно-зелёный', thumb: g3green },
  { id: 'cb-3-lightgreen', group: 3, name: 'Дизайн 3 · светло-зелёный', thumb: g3lightgreen },
  { id: 'cb-3-red', group: 3, name: 'Дизайн 3 · бордовый', thumb: g3red },
  { id: 'cb-3-brown', group: 3, name: 'Дизайн 3 · жёлтый', thumb: g3brown },
  { id: 'cb-4-black', group: 4, name: 'Дизайн 4 · чёрный', thumb: g4black },
  { id: 'cb-4-blue', group: 4, name: 'Дизайн 4 · синий', thumb: g4blue },
  { id: 'cb-4-green', group: 4, name: 'Дизайн 4 · тёмно-зелёный', thumb: g4green },
  { id: 'cb-4-lightgreen', group: 4, name: 'Дизайн 4 · светло-зелёный', thumb: g4lightgreen },
  { id: 'cb-4-red', group: 4, name: 'Дизайн 4 · бордовый', thumb: g4red },
  { id: 'cb-4-brown', group: 4, name: 'Дизайн 4 · жёлтый', thumb: g4brown },
];

export const comabooksCoverById = (id: string | null | undefined) =>
  COMABOOKS_COVERS.find((c) => c.id === id);
